import React, { Fragment } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

import { MOBILE_ANSWER_PORTAL_ID } from "apps/profile_questions/util/constants";

const ButtonWrapper = ({ children }) => {
	const portalElement = document.getElementById(MOBILE_ANSWER_PORTAL_ID);

	if (portalElement) {
		return createPortal(children, portalElement);
	} else {
		return (
			<Fragment>{children}</Fragment>
		);
	}
};

ButtonWrapper.propTypes = {
	children: PropTypes.object.isRequired,
};

export default ButtonWrapper;



// WEBPACK FOOTER //
// ./src/apps/questions/components/MultiPartQuestionWrapper/ButtonsWrapper.jsx